import supabase from '../supabase';

const API_URL = import.meta.env.VITE_API_URL;

type ApiFetchOptions = RequestInit & { isPublic?: boolean };

export async function apiFetch(
  endpoint: string,
  options: ApiFetchOptions = {},
): Promise<Response> {
  const { isPublic, ...rest } = options;
  const headers = await buildHeaders(rest, isPublic);

  const response = await fetch(`${API_URL}${endpoint}`, { ...rest, headers });

  if (response.status === 401 && !isPublic) {
    await supabase.auth.signOut();
    window.location.href = '/sign-in';
  }

  return response;
}

async function buildHeaders(
  options: RequestInit,
  isPublic: boolean | undefined,
): Promise<HeadersInit> {
  const headers: Record<string, string> = { ...(options.headers as object) };

  if (options.body && !(options.body instanceof FormData)) {
    headers['Content-Type'] = 'application/json';
  }

  if (isPublic) return headers;

  const token = await getAccessToken();
  if (token) headers['Authorization'] = `Bearer ${token}`;

  return headers;
}

async function getAccessToken(): Promise<string | undefined> {
  const {
    data: { session },
  } = await supabase.auth.getSession();
  return session?.access_token;
}
